import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { GlobalLoadingComponent } from './app/core/loading/global-loading.component';
import { LoadingUiService } from './app/core/loading/loading-ui.service';
import { ScrapingJobsService } from './app/pages/reportes/scraping-jobs.service';
import { NotificacionesStoreService } from './app/pages/notificaciones/notificaciones-store.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, ToastModule, GlobalLoadingComponent],
    template: `<p-toast position="top-right" />
        <div [attr.inert]="loading.isBlocking() ? '' : null" [attr.aria-busy]="loading.isBlocking()">
            <router-outlet></router-outlet>
        </div>
        <app-global-loading />`
})
export class AppComponent {
    readonly loading = inject(LoadingUiService);
    private readonly notificaciones = inject(NotificacionesStoreService);
    private readonly scrapingJobs = inject(ScrapingJobsService);
}
